import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { GET, PUT } from '../../../helpers/httphelper';
import EditForm from '../components/EditForm';
import { getDownloadURL, ref, uploadBytesResumable, deleteObject } from 'firebase/storage';
import { storage } from '../../../helpers/Firebase';
import { toast as superToast } from 'bulma-toast';

function EditArticle() {

  const params = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState({
    topic: '',
    body: '',
    photo: ''
  });
  const [progress, setProgress] = useState(0);
  const [imgName, setImgName] = useState("Update Photo");


  const handleUpdate = async () => {
    const ob = {
      topic: article.topic,
      body: article.body,
      photo: article.photo
    }
    try {
      const res = await PUT(`api/articles/update/${params.id}`, ob);
      console.log(res);
      superToast({
        message: res.message,
        type: 'is-success',
        dismissible: true,
        position: "top-center",
        animate: { in: 'fadeIn', out: 'fadeOut' },
      })
      navigate("/articles/user/articles");
    } catch (err) {
      console.log(err);
    }
  }

  const handleInput = (e) => {
    e.preventDefault();
    console.log(e.target.value)
    console.log(e.target.name)
    setArticle(prev => ({ ...prev, [e.target.name]: e.target.value }));
    console.log(article)
  }

  const handleImage = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    setImgName(file.name);
    if (!file) {
      return;
    } else {
      if (article.photo !== '') {
        const delRef = ref(storage, article.photo);

        deleteObject(delRef).then(() => {
          console.log('Photo Deleted from Storage');
          setProgress(0);
          setArticle(prev => ({ ...prev, photo: '' }));
        }).catch((err) => {
          console.log(err);
        });
      }

      const storageRef = ref(storage, `/Articles/${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on("state_changed", (snapshot) => {
        const prog = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        setProgress(prog);
      }, (err) => {
        console.log(err);
      }, () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          console.log(url)
          setArticle(prev => ({ ...prev, photo: url }));
        })
      })
    }
  }

  useEffect(() => {
    const getArticle = async () => {
      try {
        const res = await GET(`api/articles/get/one/${params.id}`);
        setArticle(prev => ({ ...prev, topic: res.data.topic }));
        setArticle(prev => ({ ...prev, body: res.data.body }));
        setArticle(prev => ({ ...prev, photo: res.data.photo }));
        console.log(res.data);
      } catch (err) {
        console.log(err)
      }
    }

    getArticle();
  }, [params.id]);

  return (
    <div className="container">

      <p className='title is-size-3-mobile is-1 mt-2 has-text-centered mt-5'>Edit Articles</p>
      <div className="columns">
        <div className="column is-6">
          <div className="box">
            <EditForm data={article} handleInput={handleInput} handleUpdate={handleUpdate} handleImage={handleImage} progress={progress} imgName={imgName} />
          </div>
        </div>
        <div className="column is-6 is-flex is-align-items-center">
          <div className="box">
            <figure className="image">
              <img src={article.photo} alt='' />
            </figure>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditArticle;